import { render, staticRenderFns } from "./AssignedCompetencyDetail.vue?vue&type=template&id=dae13664&scoped=true"
import script from "./AssignedCompetencyDetail.vue?vue&type=script&lang=js"
export * from "./AssignedCompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./AssignedCompetencyDetail.vue?vue&type=style&index=0&id=dae13664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae13664",
  null
  
)

export default component.exports